import { useIntl } from 'react-intl'
import {
  FilterFooter,
  FilterListbox,
  FilterOptionRadio,
  FilterPopover,
  type UseFilterStateReturn,
} from '@vtex/admin-ui'
import { BaseFilter } from '@/components/filters/BaseFilter/BaseFilter'
import { useFilter } from '@/components/filters/hooks/useFilter'

interface FilterKitProps<T> {
  state: UseFilterStateReturn<T>
}

function FilterKitPopover<T = boolean>(props: FilterKitProps<T>) {
  const { state } = props

  const { formatMessage } = useIntl()

  return (
    <FilterPopover state={state}>
      <FilterListbox>
        <FilterOptionRadio
          id="without-active-kit"
          value={false}
          label={formatMessage({
            id: 'admin/admin.catalog.without-kit-filter-option-label',
            defaultMessage: 'Inactive bundles',
          })}
        />
        <FilterOptionRadio
          id="with-active-kit"
          value={true}
          label={formatMessage({
            id: 'admin/admin.catalog.with-kit-filter-option-label',
            defaultMessage: 'Has active bundle',
          })}
        />
      </FilterListbox>
      <FilterFooter />
    </FilterPopover>
  )
}

export type SerializedData = '' | 'true' | 'false'

export function FilterKit(props: { name: string }) {
  const { formatMessage } = useIntl()

  return (
    <BaseFilter
      disclosureMessage={formatMessage({
        id: 'admin/admin.catalog.kit-filter-label',
        defaultMessage: 'Bundle',
      })}
      FilterPopoverComponent={FilterKitPopover}
      filterName={props.name}
      useFilterState={useFilter}
      toSerializableData={(data) =>
        String(data.appliedItem?.value ?? '') as SerializedData
      }
    />
  )
}
